<div content>
  @for (user of userList; track $index) {
    <button (click)="userClick(user)" [ngClass]="classForUser(user)" mat-raised-button>{{ displayName(user) }}</button>
  }
</div>

